import angular from "angular";
import { ApiCrudObject, ApiListItem, Calculations, DataMappersLogic, Exportable } from "@salaxy/core";
import { ApiCrudObjectController } from "../bases/ApiCrudObjectController";
import { ODataQueryController } from "../bases";
import { FileService, JsonSchemaService } from "../../services";

/**
 * Controller that provides export and import for odata tables and API crud objects.
 */
export class ODataActionsController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["FileService", "JsonSchemaService"];

  /** The API crud object controller. */
  public $crud: ApiCrudObjectController<ApiCrudObject, ApiListItem>;

  /** Enclosing ODataQueryController */
  public $odata : ODataQueryController;

  private calculationsUrl = new Calculations(null).getBaseUrl();

  /**
   * Constructor for Dependency Injection.
   */
  constructor(private fileService: FileService, private jsonSchemaService: JsonSchemaService) {
  }

  /**
   * Returns Exportable api for the used crud.
   * @returns Exportable api.
   */
  public getExportable(): Exportable<ApiCrudObject> {
    // TODO: Move this to Calculations related controller and remove getExportable() away from here.
    const baseUrl = this.$crud.getApi().getBaseUrl();
    switch (baseUrl) {
      case this.calculationsUrl:
        return {
          getExportMappers: () => DataMappersLogic.getMappers(["Calculation", "CalculationListItem"]),
          getExportMapper: (id) => DataMappersLogic.getBuiltInMapper(id, this.jsonSchemaService.getCache()),
          exporters: this.fileService.getDefaultExporters(),
          getSingle: (item) => this.$crud.getApi().getSingle(item.id),
          list: (maxCount?, notify?) => this.$odata.exportItems(maxCount ?? 0, notify),
        };
      default:
        return null;
    }
  }
}
